import { OpenInNew } from '@mui/icons-material';
import { FormattedMessage } from 'react-intl';
import React from 'react';
import { DataTableButton } from './style';
import { ShowMoreFooterProps } from '../types';

export default function ShowMoreFooter({ onClick }: ShowMoreFooterProps) {
  return (
    <DataTableButton variant="text" endIcon={<OpenInNew />} onClick={onClick}>
      <FormattedMessage id="landing.page.table.footer" defaultMessage="Show More" />
    </DataTableButton>
  );
}
